<template>
    <div v-if="cmsPage" class="brands-overview">
        <section class="section page-wrapper brands-overview__section">
            <div class="section__content">
                <h1 class="section__heading">{{ cmsPage.heading }}</h1>
                <div v-if="cmsPage.content" class="brands-overview__description">
                    <!-- eslint-disable-next-line vue/no-v-html We trust our own CMS pages -->
                    <div v-html="cmsPage.content" />
                </div>
                <div v-if="cmsPage && cmsPage.children.length > 0" class="brands-overview__brands">
                    <p class="brands-overview__title">
                        {{ $t('pages.brands_overview.list_title') }}
                    </p>
                    <div class="brands-overview__brands-wrapper">
                        <LocalizedLink
                            v-for="brandPage in cmsPage.children"
                            :key="brandPage.id"
                            :to="brandPage.path"
                            class="brands-overview__brand"
                        >
                            {{ brandPage.breadcrumbTitle }}
                        </LocalizedLink>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'BrandOverview',
    computed: {
        ...mapGetters(['cmsPage']),
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.brands-overview {
    @include font-size(16px);

    .section__content {
        max-width: 680px;
    }

    .section__heading {
        margin-bottom: 32px;
    }

    &__section {
        padding-top: 40px;
        padding-bottom: 20px;
    }

    &__description {
        margin-bottom: 32px;
    }

    &__title {
        margin-bottom: 32px;
        font-weight: bold;
        @include font-size(20px);
    }

    &__brands-wrapper {
        display: flex;
        flex-wrap: wrap;
    }

    &__brand {
        flex: 0 0 50%;
        max-width: 50%;
        text-align: left;
        line-height: 1.5;
        color: $primary;
        margin-bottom: 16px;

        @include lg {
            flex: 0 0 16.6667%;
            max-width: 16.6667%;
        }
    }
}
</style>
